import { GET_STATES, SET_STATES } from "./StatesType";

const getStates = () => ({
    type: GET_STATES,
});

const setStates = (statesDropDownList: any) => ({
    type: SET_STATES,
    statesDropDownList
});

export {
    getStates,
    setStates
}
